var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutrosImoveis = function SvgOutrosImoveis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3306 0.502C10.9306 0.167 10.4846 0 9.99261 0C9.50161 0 9.05461 0.167 8.65461 0.502L0.302612 7.241C0.0136124 7.591 -0.0683877 7.97 0.0566123 8.377C0.181612 8.785 0.484612 8.989 0.967612 8.989L1.99561 9L1.99961 18C1.99961 19.333 2.66661 19.996 3.99961 19.986H5.99961C7.33261 19.976 13.9996 20 13.9996 20H15.9996C17.3326 20 17.9996 19.333 17.9996 18V9L18.9836 8.989C19.4456 8.987 19.7546 8.784 19.9106 8.377C20.0666 7.971 19.9806 7.594 19.6526 7.245L11.3306 0.502ZM5 12.5C5.69036 12.5 6.25 11.9404 6.25 11.25C6.25 10.5596 5.69036 10 5 10C4.30964 10 3.75 10.5596 3.75 11.25C3.75 11.9404 4.30964 12.5 5 12.5ZM11.25 11.25C11.25 11.9404 10.6904 12.5 10 12.5C9.30964 12.5 8.75 11.9404 8.75 11.25C8.75 10.5596 9.30964 10 10 10C10.6904 10 11.25 10.5596 11.25 11.25ZM15 12.5C15.6904 12.5 16.25 11.9404 16.25 11.25C16.25 10.5596 15.6904 10 15 10C14.3096 10 13.75 10.5596 13.75 11.25C13.75 11.9404 14.3096 12.5 15 12.5Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutrosImoveis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outros-imoveis.61916d64.svg";
export { ForwardRef as ReactComponent };